<template>
  <div v-show="isShow">
    <template v-if="isPc">
      <div class="publicHeader">
        <div class="logo">
          <a href="//www.qingcloud.com">
            <img :src="require('@/logo4.png')" />
          </a>
        </div>
        <ul class="navs">
          <li v-for="(item, index) in navs" :key="index">
            <template v-if="!isArray(item)">
              <template v-if="item.url">
                <a style="color: #fff !important" :href="item.url">{{
                  item.title
                }}</a>
              </template>
              <template v-if="!item.url">
                <a
                  style="color: #fff !important"
                  :href="'index#' + item.point"
                  >{{ item.title }}</a
                >
              </template>
            </template>
          </li>
        </ul>

        <!--
				 <div v-if="!userId" class="right">
					 <a href="login"><img :src="require('@/user@2x.png')" /> 登录</a>
					 <img  :src="require('@/Vline.png')" />
					 <a href="register"><img :src="require('@/bi@2x.png')" /> 报名</a>
				 </div>
				 -->
        <div
          style="
            position: relative;
            min-width: auto;
            width: 1.01rem;
            height: 0.25rem;
            padding: 0;
          "
          v-if="userId"
          class="right"
        >
          <a
            style="width: 1rem"
            @click.prevent.stop="showLogout = !showLogout"
            href="javascript:void(0)"
          >
            <img :src="require('@/user@2x.png')" /> {{ name }}
            <img
              style="width: 0.09rem; height: 0.05rem"
              :src="require('@/index/jiantouxia@2x.png')"
            />
          </a>

          <a
            v-show="showLogout"
            style="
              color: #3e3d49;
              left: 0px;
              bottom: -100%;
              background-color: #fff;
              position: absolute;
              width: 100%;
              height: 100%;
            "
            href="/logout"
          >
            <img
              style="width: 0.1rem; height: 0.1rem"
              :src="require('@/index/guanji@2x 2.png')"
            />
            退出
          </a>
        </div>
      </div>
    </template>

    <template v-if="!isPc">
      <div class="publicHeader">
        <div class="logo">
          <a href="//www.qingcloud.com">
            <img :src="require('@/logo4.png')" />
          </a>
        </div>

        <div @click.prevent.stop="showNav = !showNav" class="menuBtn">
          <img :src="require('@/mobileMenuBtn.png')" />
        </div>
      </div>

      <ul :class="{ show: showNav }" class="navs">
        <li
          @click.stop="showNav = !showNav"
          v-for="(item, index) in navs"
          :key="index"
        >
          <template v-if="!isArray(item)">
            <template v-if="item.url">
              <a :href="item.url">{{ item.title }}</a>
            </template>
            <template v-if="!item.url">
              <a :href="'index#' + item.point">{{ item.title }}</a>
            </template>
          </template>
        </li>

        <!--
				 <template  v-if="!userId">
				 	<li>

						<a style="color: rgba(0, 169, 113, 1);    margin-left: 0.1rem;" href="login">
							<img style="width: 0.26rem;height: 0.29rem;" :src="require('@/greenUser@2x.png')" /> 登录
						</a>
				 	</li>

				 	<li>
				 		<a  style="color: rgba(0, 169, 113, 1);    margin-left: 0.1rem;" href="register">
							<img style="width: 0.25rem;height: 0.25rem;" :src="require('@/greenEdit@2x.png')" /> 报名
						</a>
				 	</li>
				 </template>
				 -->
        <template v-if="userId">
          <li>
            <img
              style="width: 0.26rem; height: 0.29rem"
              :src="require('@/greenUser@2x.png')"
            />
            <span style="color: rgba(0, 169, 113, 1); margin-left: 0.1rem">{{
              name
            }}</span>
          </li>
          <li>
            <a
              style="color: rgba(0, 169, 113, 1); margin-left: 0.1rem"
              href="/logout"
            >
              <img
                style="width: 0.29rem; height: 0.29rem"
                :src="require('@/greenLogout@2x.png')"
              />
              退出
            </a>
          </li>
        </template>
      </ul>
    </template>
  </div>
</template>

<script>
import { os } from '../../utils'
import { mxuserInfo } from '../../utils/mixins'

export default {
  name: 'publicHeader',
  mixins: [mxuserInfo],
  props: {
    msg: String
  },
  data() {
    return {
      navs: window.pageData['navs'],
      showNav: false,
      isPc: os.isPc,
      isShow: false,
      name: '',
      userId: '',
      showLogout: false
    }
  },
  beforeCreate() {
    if (!os.isPc) {
      /*
	  this.$nextTick(() => {
		  this.navs.push({title : '登录 | 报名'})
	  })
	  */
      import('./styles/mobile.scss').then(() => {
        this.$nextTick(() => {
          this.isShow = true
        })
      })
      console.log('mobile')
    } else {
      console.log('pc')
      import('./styles/pc.scss').then(() => {
        this.$nextTick(() => {
          this.isShow = true
        })
      })
    }
  },
  created() {
    // console.log(this.userId)
    //this.isPc = os.isPc;

    setInterval(() => {
      if (window.userInfo) {
        this.userId = window.userInfo['id']
        this.name = window.userInfo['name']
      }
    }, 100)

    document.addEventListener('click', () => {
      if (this.isPc) this.showLogout = false
      if (!this.isPc) this.showNav = false
    })
    //document.
  },
  methods: {
    isArray(obj) {
      return !(typeof obj.length == 'undefined')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
